import { highlights } from '@/mocks/entertainment';

const principles = [
  { icon: 'ri-focus-3-line', title: '来源可溯', desc: '每条热点标注首发信源与时间，看得见它的来龙去脉。' },
  { icon: 'ri-git-branch-line', title: '动态核实', desc: '实锤与传闻分得清，重大消息持续跟进二次验证。' },
  { icon: 'ri-speed-line', title: '先人一步', desc: '全天滚动追踪，热点还在发酵时你已经在场。' },
  { icon: 'ri-emotion-line', title: '好好说话', desc: '吃瓜可以，带节奏不行。保持克制，把判断交给事实。' },
];

export default function AboutSection() {
  return (
    <section id="about" className="mx-auto max-w-7xl px-4 md:px-6 pt-16 md:pt-24">
      <div className="rounded-3xl overflow-hidden border border-background-200/70 bg-background-50">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          {/* story */}
          <div className="p-6 md:p-10 bg-gradient-to-br from-accent-100 via-accent-50 to-background-50">
            <p className="text-xs font-bold tracking-widest text-accent-700 mb-2">ABOUT US</p>
            <h3 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">关于「最快吃瓜」</h3>
            <p className="mt-4 text-[15px] leading-relaxed text-foreground-700">
              我们是一支内容团队，专注一件事：让资讯在它还有温度的时候，就送到你手里。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              从筹备算起，「最快吃瓜」最初只是几个编辑蹲在热搜底下抢前排的小群。后来我们想，与其拼手速，不如把"快到让人追不上"变成一套可靠的方法——于是有了今天这个全天滚动、逐条核实的平台。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              我们不生产谣言，只负责把真实发生、正在被讨论的事，讲得清楚、讲得及时、讲得克制。
            </p>
            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {highlights.map((h) => (
                <div key={h.title} className="rounded-2xl bg-background-50/80 border border-background-200/60 p-4 text-center">
                  <p className="font-display text-xl text-primary-600">{h.num}</p>
                  <p className="mt-1 text-xs text-foreground-600">{h.title}</p>
                </div>
              ))}
            </div>
          </div>

          {/* principles */}
          <div className="p-6 md:p-10 grid grid-cols-1 sm:grid-cols-2 gap-4 content-center">
            <div className="sm:col-span-2">
              <h4 className="font-heading text-xl font-black text-foreground-950 flex items-center gap-2">
                <span className="w-1.5 h-5 rounded-full bg-primary-500"></span>我们怎么帮你"吃明白瓜"
              </h4>
            </div>
            {principles.map((item) => (
              <div key={item.title} className="rounded-2xl border border-background-200/70 bg-background-50 p-5 hover:border-accent-300 transition">
                <span className="w-11 h-11 rounded-xl bg-primary-100 text-primary-600 flex items-center justify-center">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h5 className="mt-3 font-bold text-foreground-950">{item.title}</h5>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}